import { createContext } from "react";

export const PricesContext = createContext(null);
